var t=function(t,r){var e;return void 0===r&&(r=300),function(){for(var n=this,o=[],u=0;u<arguments.length;u++)o[u]=arguments[u];clearTimeout(e),e=setTimeout((function(){return t.apply(n,o)}),r)}};export{t as default};
//# sourceMappingURL=debounce.mjs.map
